import axios from 'axios';
import { OCP_APIM_VALUE, ONLINE_API_ENDPOINT, TOKEN_VALUE } from '../Configs';

export const OnlineAPIServiceEngine = axios.create({
    baseURL: ONLINE_API_ENDPOINT,
    timeout: 100000,
    headers: {
        'Ocp-Apim-Subscription-Key': OCP_APIM_VALUE,
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+ TOKEN_VALUE
    }
});

export default {
    OnlineAPIServiceEngine
};